import styled from "styled-components";

export const DividerLine = styled.div`
  width: 100%;
  height: 2px;
  background: linear-gradient(
    to right,
    transparent,
    #01e735,
    #01ead4,
    #01e735,
    transparent
  );
`;
